import { createAction } from "@reduxjs/toolkit";
import { SupportedNetwork } from "constants/networks";
import { PoolInfo, PoolDetails } from './reducer';

export const setPool = createAction<{ pools: Array<PoolInfo> }>('pool/setPool');
export const setDetails = createAction<{ poolDetails: PoolDetails; networkId: SupportedNetwork }>('pool/setPoolsDetails');
export const updatePoolData = createAction<{ pools: Array<PoolInfo>; networkId: SupportedNetwork }>('pool/updatePoolData')
export const addPoolKeys = createAction<{ poolAddresses: string[]; networkId: SupportedNetwork }>('pool/addPoolKeys')